import { Button, Checkbox, FormGroup, HTMLSelect } from '@blueprintjs/core'
import * as React from 'react'
import { CSSProperties } from 'react'
import ReactTable from 'react-table'
import checkboxHOC from 'react-table/lib/hoc/selectTable'
import Spinner from '../../../components/Spinner'
import { getSort } from '../../../utils'

const paginationButtonStyle: CSSProperties = {
  width: 100,
  textAlign: 'center'
}

const style = {
  pagination: {
    button: paginationButtonStyle,
    pageSize: {
      marginLeft: 20,
      marginRight: 20,
      marginBottom: 0
    },
    div: {
      marginTop: 10,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }
}

const Table = checkboxHOC(ReactTable)

const ReactTableBlueprintCheckbox = ({ checked, onClick, id, row }) => (
  <Checkbox checked={checked} onChange={e => onClick(id, e, row)} />
)

const CursorPaginatedTable = ({ meta, onMetaChange, data, idKey, ...rest }) => {
  return (
    <>
      <Table
        className="-striped"
        loadingText={<Spinner />}
        manual
        pageSize={meta?.perPage || 10}
        selectType="checkbox"
        SelectInputComponent={ReactTableBlueprintCheckbox}
        SelectAllInputComponent={ReactTableBlueprintCheckbox}
        showPaginationBottom={false}
        sorted={getSort(meta?.sort)}
        onSortedChange={sort => onMetaChange('sort', sort.map(s => `${s.id}.${s.desc ? 'desc' : 'asc'}`)[0])} // only support one sort for now
        {...rest}
        data={data.map(entry => ({
          _id: entry[idKey || 'id'],
          ...entry
        }))}
      />
      <div style={style.pagination.div}>
        <Button
          large
          style={style.pagination.button}
          onClick={() => onMetaChange('cursor', meta?.previousCursor)}
          disabled={!meta?.previousCursor}
          loading={rest.loading}
        >
          Previous
        </Button>{' '}
        <FormGroup inline label="Page size" style={style.pagination.pageSize}>
          <HTMLSelect
            options={[{ value: 10 }, { value: 15 }, { value: 30 }, { value: 50 }, { value: 100 }]}
            value={meta?.perPage || 10}
            onChange={e => onMetaChange('perPage', e.target.value)}
            disabled={rest.loading}
          />
        </FormGroup>
        <Button
          large
          style={style.pagination.button}
          onClick={() => onMetaChange('cursor', meta?.nextCursor)}
          disabled={!meta?.nextCursor}
          loading={rest.loading}
        >
          Next
        </Button>
      </div>
    </>
  )
}

export { CursorPaginatedTable }
export default React.memo(CursorPaginatedTable)
